import type { PropsWithChildren } from 'react';

import { useLocation } from '@tanstack/react-router';

import { Skeleton } from '@/_components';

export function LeftHeaderSectionSkeleton({
  children,
  allowBack,
  withBreadcrumb = false,
}: PropsWithChildren<{ allowBack?: boolean; withBreadcrumb?: boolean }>) {
  const { state } = useLocation();

  return (
    <>
      <section>
        <div className="flex items-center gap-4">
          {(allowBack || state?.naturalBack) && <Skeleton className="size-8" />}
          <Skeleton className="h-8 w-56 rounded-xl" />
        </div>

        {withBreadcrumb && <Skeleton className="mt-1 h-5 w-72 rounded-lg" />}
      </section>
      {children}
    </>
  );
}
